import Select from "react-select";
import { colors } from "../../colors";
import { SelectProps } from "./dto";
import './style.css';

export function SelectCustom(props: SelectProps) {
    return (
        <div className="w-[100%] flex flex-col gap-[4px]">
            {props.label && <span className="input-label">{props.label}</span>}
            <Select
                isSearchable={props.isSearchable}
                hideSelectedOptions={props.hideSelectedOptions}
                isDisabled={props.disabled}
                menuPlacement="auto"
                isMulti={props.isMulti}
                menuPortalTarget={props.menuPortalTargetIsNotBody ? undefined : document.body}
                options={props.options}
                noOptionsMessage={() => <span className="text-text-sm">{props.noOptionsMessage}</span>}
                isClearable={props.isClearable}
                placeholder={props.placeholder}
                //@ts-ignore
                onChange={(e) => props.onChange && props.onChange(props.isMulti ? e.map(e => e.value) : e?.value)}
                defaultValue={
                    props.defaultValue !== undefined ?
                        props.isMulti ?
                            props.options?.filter(opt => props.defaultValue?.includes(opt.value))
                            :
                            props.options?.find(opt => opt.value === props.defaultValue)
                        :
                        null
                }
                value={
                    props.defaultValue !== undefined ?
                        props.isMulti ?
                            props.options?.filter(opt => props.defaultValue?.includes(opt.value))
                            :
                            props.options?.find(opt => opt.value === props.defaultValue)
                        :
                        null
                }
                styles={{
                    placeholder: (baseStyles) => ({
                        ...baseStyles,
                        fontSize: '14px',
                        lineHeight: '16px',
                        color: colors.neutral[400],
                        fontFamily: 'Manrope',
                        fontWeight: 500
                    }),
                    option: (baseStyles, props) => ({
                        ...baseStyles,
                        fontSize: '14px',
                        lineHeight: '20px',
                        color: props.isSelected ? colors.white : colors.neutral[600],
                        fontFamily: 'Manrope',
                        fontWeight: 500,
                        backgroundColor: props.isSelected ? colors.neutral[200] : colors.white,
                        '&:hover': {
                            backgroundColor: colors.brandPrimary[200]
                        }
                    }),
                    input: (baseStyles, props) => ({
                        ...baseStyles,
                        fontSize: '14px',
                        lineHeight: '20px',
                        color: colors.neutral[600],
                        fontFamily: 'Manrope',
                        fontWeight: 500
                    }),
                    singleValue: (baseStyles, props) => ({
                        ...baseStyles,
                        fontSize: '14px',
                        lineHeight: '20px',
                        color: colors.neutral[600],
                        fontFamily: 'Manrope',
                        fontWeight: 500
                    }),
                    multiValue: (baseStyles, props) => ({
                        ...baseStyles,
                        fontSize: '14px',
                        lineHeight: '20px',
                        color: colors.brandPrimary[900],
                        fontFamily: 'Manrope',
                        fontWeight: 500,
                        padding: '0px 8px',
                        minWidth: 'auto',
                        borderRadius: 8,
                        backgroundColor: colors.brandPrimary[200],
                        border: '1px solid ' + colors.brandPrimary[400],
                        overflow: 'hidden',  // Nasconde l'overflow
                        textOverflow: 'ellipsis',  // Applica l'ellisse quando necessario
                        whiteSpace: 'nowrap',  // Impedisce la rottura di riga
                        maxWidth: '100%',  // Limita la larghezza massima
                    }),
                    multiValueLabel: (baseStyles, props) => ({
                        ...baseStyles,
                        width: '100%',
                        display: "block",
                        overflow: 'hidden',  // Nasconde l'overflow
                        textOverflow: 'ellipsis',  // Applica l'ellisse per i testi lunghi
                        whiteSpace: 'nowrap',  // Impedisce la rottura di riga
                        maxWidth: 'calc(100% - 20px)',  // Lascia spazio per l'icona di rimozione
                    }),
                    multiValueRemove: (baseStyles, props) => ({
                        ...baseStyles,
                        color: colors.neutral[500],
                        '&:hover': {
                            color: colors.brandPrimary[600],
                            backgroundColor: colors.brandPrimary[200],
                        }
                    }),
                    indicatorsContainer: (baseStyles) => ({
                        ...baseStyles,
                        alignItems: 'center',
                        height: props.keepOverflow ? '40px' : undefined
                    }),
                    container: (baseStyles) => ({
                        ...baseStyles,
                        width: '100%',
                        maxWidth: '100%',
                        minHeight: "40px",
                        height: props.keepOverflow ? '40px' : undefined,
                    }),
                    control: (baseStyles, state) => ({
                        ...baseStyles,
                        minHeight: "40px",
                        height: props.keepOverflow ? '40px' : undefined,
                        width: '100%',
                        maxWidth: '100%',
                        borderRadius: '8px',
                        backgroundColor: props.disabled ? 'rgba(242, 242, 250, 1)' : 'white',
                        boxShadow: 'none',
                        border: (props.error ? '1px solid ' + colors.red[300] : state.isFocused ? '1px solid ' + colors.neutral[400] : '1px solid ' + colors.neutral[400]),
                        fontFamily: 'Manrope',
                        padding: '0px 12px',
                        '&:hover': {
                            border: '1px neutral ' + colors.neutral[400]
                        }
                    }),
                    valueContainer: (baseStyles, state) => ({
                        ...baseStyles,
                        padding: props.keepOverflow ? 0 : "4px 0px",
                        height: props.keepOverflow ? '40px' : undefined,
                        overflow: "auto",
                    }),
                    indicatorSeparator: (baseStyles, state) => ({
                        display: 'none'
                    }),
                    dropdownIndicator: (baseStyles, state) => ({
                        color: state.isFocused ? colors.neutral[500] : colors.neutral[500]
                    }),
                    menuPortal: base => ({ ...base, zIndex: 40 })
                }}
            />
            {
                props.error &&
                <span className="text-text-sm text-red-500">{props.errorLabel}</span>
            }
        </div>
    )
}